<template>
  <div>
  <svg width="100%"
       height="36px" style="display: block" >
    <g v-for="vente in ventes" :key="vente.key" :ref="vente.key" @click="ajouterAuPanier(vente)"
      v-bind:class="{'pointer': typeVente != sansTypeVente}">
      <rect
        :x="vente.x1WithPaddingString" y="0" :width="vente.widthWithPaddingString"
        rx="2" ry="2" height="100%"
        :stroke="vente.stroke" stroke-width="2" :fill="vente.fill"/>
      <text v-if="vente.texte && vente.selectionne"
        :x="vente.xmilieuWithPaddingString" y="50%" dominant-baseline="central" text-anchor="middle"
        font-size="14" fill="white" style="font-weight:bold;">{{ vente.texte }}</text>
    </g>
  </svg>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import getRectangle from '@/services/catalogue/planningHelper';
import decorateurRectangleReseauxNumeriques from '@/services/decorateur/decorateurRectangleReseauxNumeriques';
import decorateurRectangleReseauxNumeriquesVente from '@/services/decorateur/decorateurRectangleReseauxNumeriquesVente';
import { GRANULARITY, GRANULARITY_DAY, SANS_TYPE_VENTE } from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import * as types from '@/store/creationOpportunite/venteReseauxNumerique-mutation-type';

const VenteReseauxNumerique = createNamespacedHelpers('venteReseauxNumerique');

export default {
  props: ['data', 'index'],
  data() {
    return {
      sansTypeVente: SANS_TYPE_VENTE,
      dataSelectionAccess: {},
      granularityDay: GRANULARITY[GRANULARITY_DAY],
    };
  },
  computed: {
    ...VenteReseauxNumerique.mapGetters([
      'criterePlanning',
      'typeVente',
    ]),
    ventes() {
      const ventesArray = [];
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateEnd;

      for (const m = moment(dateStart); m.diff(dateEnd, 'days') <= 0; m.add(1, 'days')) {
        const result = getRectangle(this.criterePlanning, m, m);
        if (result !== null) {
          const key = `r${this.data.num}${m.format('YYYYMMDD')}`;
          if (this.dataSelectionAccess[key]) {
            result.selectionne = this.dataSelectionAccess[key];
          }
          decorateurRectangleReseauxNumeriques(result, this.data.faces, m, m);
          decorateurRectangleReseauxNumeriquesVente(result, this.data.num, m, GRANULARITY_DAY);
          ventesArray.push(result);
        }
      }
      return ventesArray;
    },
  },
  methods: {
    ...VenteReseauxNumerique.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ...VenteReseauxNumerique.mapMutations({
      setReseauSelected: types.SET_RESEAU_SELECTED,
    }),
    ajouterAuPanier(vente) {
      if (this.typeVente === this.sansTypeVente) {
        return;
      }
      const tarification = this.typeVente + this.granularityDay.value;
      this.setReseauSelected({
        num: vente.num,
        value: true,
      });
      this.$set(this.dataSelectionAccess, vente.key, this.typeVente);
      this.actionsGestionPanier({
        num: vente.num,
        periode: vente.periode,
        tarification: tarification,
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/recherche/planningNumeriqueJourSvg.vue